/* Shared, dependency-free Cart drawer rules. Loaded before carska-cart.js. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.CarskaCartCore = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function cleanTitle(value) {
    return String(value || '').replace(/^Carska\s+/i, '');
  }

  function selectedVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) { return variant && variant.available; }) || null;
  }

  /* Nazwa produktu w katalogu bywa "Nazwa (50 ml)" albo "Nazwa. 21 Buteleczek x 10 ml"
     (Shopify product.title, nie coś dopisywane tutaj). Do karty oferty rozbijamy to na
     nazwę i osobną linię ilości, żeby nie renderować obu w jednym zdaniu zwykłym tekstem. */
  function splitTitleQuantity(title) {
    var text = String(title || '').trim();
    var parens = text.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
    if (parens) return { name: parens[1].replace(/[.\s]+$/, '').trim(), quantity: parens[2].trim() };
    var dot = text.lastIndexOf('. ');
    if (dot > 0) {
      var tail = text.slice(dot + 2).trim();
      if (/\d/.test(tail)) return { name: text.slice(0, dot).trim(), quantity: tail };
    }
    return { name: text, quantity: '' };
  }

  function toUpsellOffer(product) {
    var variant = selectedVariant(product);
    if (!variant) return null;
    var parts = splitTitleQuantity(cleanTitle(product.title));
    return {
      handle: product.handle,
      title: parts.name,
      quantity: parts.quantity,
      url: product.url,
      image: product.featured_image || null,
      variantId: variant.id,
      price: variant.price,
      compareAtPrice: variant.compare_at_price > variant.price ? variant.compare_at_price : null
    };
  }

  /* Handle w koszyku: linie + skladniki zestawow (bundle components). */
  function excludedUpsellHandles(cart, bundles) {
    var excluded = {};
    (cart && cart.items || []).forEach(function (item) {
      if (item && item.handle) excluded[item.handle] = true;
    });
    (bundles || []).forEach(function (bundle) {
      (bundle && bundle.components || []).forEach(function (component) {
        if (component && component.handle) excluded[component.handle] = true;
      });
    });
    return excluded;
  }

  /* Silnik ofert warunkowych (projekt: migracja/raporty/warunkowe-oferty-koszyka-projekt-2026-09-02.md).
     Kolejnosc: koszyk >= prog -> highCart; kotwica (pierwsza z listy rang obecna w koszyku,
     takze jako skladnik zestawu) -> jej oferty; potem fallback. Bez produktow z koszyka, bez duplikatow.
     Zwraca pelny uporzadkowany plan; dostepnosc i zdjecie filtruje warstwa renderujaca. */
  function findAnchor(inCart, rules) {
    var anchors = (rules && rules.anchors) || [];
    for (var i = 0; i < anchors.length; i += 1) {
      if (anchors[i] && inCart[anchors[i].handle]) return anchors[i];
    }
    return null;
  }

  function buildOfferPlan(cart, bundles, rules, options) {
    var threshold = (options && options.threshold) || 0;
    var inCart = excludedUpsellHandles(cart, bundles);
    var total = Number(cart && cart.total_price) || 0;
    var plan = [];
    if (threshold > 0 && total >= threshold) plan = plan.concat((rules && rules.highCart) || []);
    var anchor = findAnchor(inCart, rules);
    if (anchor) plan = plan.concat(anchor.offers || []);
    plan = plan.concat((rules && rules.fallback) || []);
    var seen = {};
    return plan.filter(function (rule) {
      if (!rule || !rule.handle || inCart[rule.handle] || seen[rule.handle]) return false;
      seen[rule.handle] = true;
      return true;
    }).map(function (rule) {
      return { handle: rule.handle, label: rule.label || '', note: rule.note || '', featured: !!rule.featured, anchor: anchor ? anchor.handle : null };
    });
  }

  function createRenderVersion() {
    var current = 0;
    return {
      next: function () { current += 1; return current; },
      isCurrent: function (version) { return version === current; }
    };
  }

  return {
    cleanTitle: cleanTitle,
    splitTitleQuantity: splitTitleQuantity,
    selectedVariant: selectedVariant,
    toUpsellOffer: toUpsellOffer,
    excludedUpsellHandles: excludedUpsellHandles,
    findAnchor: findAnchor,
    buildOfferPlan: buildOfferPlan,
    createRenderVersion: createRenderVersion
  };
});
